import { GiRoundStar } from 'react-icons/gi';
import IconContainer from '../components/IconContainer/IconContainer';
import './Story.css';
import { getIcons } from '../utils/getIcons';

const Etherial = () => {
  const icons = getIcons(['resource-science', 'resource-crystals']);

  if (icons.length < 2) {
    return <div>'NO ICON'</div>;
  }

  return (
    <div className="story-container">
      <div className="story-row">
        4
        <GiRoundStar color="orange" size={15} className="story-star" />
        if you have at least 2
        <div className="story-icon-wrapper">
          <IconContainer icon={{ ...icons[0], size: 'sm' }} />
        </div>{' '}
        and 2{' '}
        <div className="story-icon-wrapper">
          <IconContainer icon={{ ...icons[1], size: 'sm' }} />
        </div>
      </div>
    </div>
  );
};

export default Etherial;
